import {
  RESET_DEPARTMENTS,
  RESET_DEPARTMENT,
  RESET_ERROR,
  GET_DEPARTMENTS,
  SET_DEPARTMENTS,
  API_ERROR,
  CREATE_DEPARTMENT,
  CREATE_DEPARTMENT_SUCCESS,
  GET_DEPARTMENT,
  SET_DEPARTMENT,
  EDIT_DEPARTMENT,
  EDIT_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT,
  DELETE_DEPARTMENT_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorDepartment: false,
  loadingDepartment: false,
  dataDepartment: null,
  successDepartment: false,
};

const Department = (state = initialState, action) => {
  switch (action.type) {
    case RESET_DEPARTMENTS:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartment: false,
        loadingDepartmentDelete: false,
        successDepartment: false,
        dataDepartment: null,
        dataDepartmentDelete: null,
      };
      break;
    case RESET_DEPARTMENT:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartment: false,
        successDepartment: false,
        dataDepartmentGetSet: null,
        dataDepartmentEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartment: false,
        loadingDepartmentEditCreate: false,
        loadingDepartmentActivate: false,
        successDepartment: false,
      };
      break;
    case GET_DEPARTMENTS:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartment: true,
        dataDepartment: null,
      };
      break;
    case SET_DEPARTMENTS:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartment: false,
        dataDepartment: action.payload,
      };
      break;
    case CREATE_DEPARTMENT:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartmentEditCreate: true,
        dataDepartmentEditCreate: action.payload,
        successDepartment: false,
      };
      break;
    case CREATE_DEPARTMENT_SUCCESS:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartmentEditCreate: false,
        dataDepartmentEditCreate: action.payload,
        successDepartment: true,
      };
      break;
    case GET_DEPARTMENT:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartment: true,
        dataDepartmentGetSet: null,
      };
      break;
    case SET_DEPARTMENT:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartment: false,
        dataDepartmentGetSet: action.payload,
      };
      break;
    case EDIT_DEPARTMENT:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartmentEditCreate: true,
        dataDepartmentEditCreate: action.payload,
        successDepartment: false,
      };
      break;
    case EDIT_DEPARTMENT_SUCCESS:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartmentEditCreate: false,
        dataDepartmentEditCreate: action.payload,
        successDepartment: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorDepartment: action.payload,
        loadingDepartment: false,
        loadingDepartmentDelete: false,
        successDepartment: false,
      };
      break;
    case DELETE_DEPARTMENT:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartmentDelete: true,
        dataDepartmentDelete: action.payload,
        successDepartment: false,
      };
      break;
    case DELETE_DEPARTMENT_SUCCESS:
      state = {
        ...state,
        errorDepartment: false,
        loadingDepartmentDelete: false,
        dataDepartmentDelete: action.payload,
        successDepartment: true,
      };
      break;
    default:
      // state = { ...state, errorDepartment: false, loadingDepartment: false };
      break;
  }
  return state;
};

export default Department;
